import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  TenantRoleContainerModel, TenantRoleService
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';

@Component({
  selector: 'app-role-dropdown',
  templateUrl: './role-dropdown.component.html',
  styleUrls: ['./role-dropdown.component.css']
})
export class RoleDropdownComponent implements OnInit, OnDestroy {

  @Input() role: FormControl;
  @Output() roleChange = new EventEmitter<FormControl>();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<TenantRoleContainerModel[]> = new ReplaySubject<TenantRoleContainerModel[]>(1);
  roleList: TenantRoleContainerModel[];

  constructor( private roleService: TenantRoleService ) {}

  ngOnInit() {
    this.subs.sink = this.roleService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.roleList = resolve.data;
        this.filteredOptions$.next(this.roleList);
      }});
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterApplet(resolve)});
  }

  filterApplet(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.roleList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.roleList.filter(c => c.app_mst_role.code.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
